/**
 * Eager route chunk prefetching utilities.
 */
export const PREFETCH: Record<string, () => Promise<unknown>> = {
  '/': () => import('@/pages/overview/OverviewPage'),
  '/chatbot': () => import('@/pages/chatbot/ChatbotPage'),
  '/users': () => import('@/pages/users/UsersPage'),
  '/settings': () => import('@/pages/settings/SettingsPage'),
  '/audit': () => import('@/pages/audit/AuditPage'),
}
